import { apiClient } from './client'
import type { UnderstandResponse } from '@/types/content'
import type { InteractionSourceType } from './interactions'

export interface UnderstandPayload {
  selection: string
  context?: string
  sourceType: InteractionSourceType
  articleId?: string
}

export const understandApi = {
  understand: (payload: UnderstandPayload) =>
    apiClient.post<UnderstandResponse>('/understand', payload),

  /** C2 — save grammar construction as Understanding Snapshot. */
  saveGrammarEpisode: (payload: CreateGrammarEpisodePayload) =>
    apiClient.post<UnderstandingEpisodeSummary>('/understand/episodes/grammar', payload),
}

export interface CreateGrammarEpisodePayload {
  span: string
  sentence?: string
  heroL1?: string
  headline?: string
  formRecipe?: string
  nestedSurface?: string
  nestedL1?: string
  confidence?: number
  articleId?: string
}

export interface UnderstandingEpisodeSummary {
  id: string
  evidenceKind: 'WORD' | 'PHRASE' | 'GRAMMAR'
  span: string
  sentence?: string | null
  heroL1?: string | null
  confidence?: number | null
  languageCode: string
  articleId?: string | null
  status: string
  createdAt?: string | null
}
